import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["aria-label", "aria-expanded"];
const _hoisted_2 = {
    class: "language-switcher__flag",
    "aria-hidden": "true"
};
const _hoisted_3 = {
    key: 0,
    viewBox: "0 0 3 2"
};
const _hoisted_4 = {
    key: 1,
    viewBox: "0 0 60 30"
};
const _hoisted_5 = {
    key: 2,
    viewBox: "0 0 3 2"
};
const _hoisted_6 = {
    key: 3,
    viewBox: "0 0 27 18"
};
const _hoisted_7 = { class: "language-switcher__code" };
const _hoisted_8 = ["aria-label"];
const _hoisted_9 = ["aria-selected", "onClick"];
const _hoisted_10 = {
    class: "language-switcher__flag",
    "aria-hidden": "true"
};
const _hoisted_11 = {
    key: 0,
    viewBox: "0 0 3 2"
};
const _hoisted_12 = {
    key: 1,
    viewBox: "0 0 60 30"
};
const _hoisted_13 = {
    key: 2,
    viewBox: "0 0 3 2"
};
const _hoisted_14 = {
    key: 3,
    viewBox: "0 0 27 18"
};
const _hoisted_15 = { class: "language-switcher__name" };
const _hoisted_16 = { class: "language-switcher__code" };
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { localeDisplayKey, setAppLocale, SUPPORTED_LOCALES, } from "@/i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LanguageSwitcher',
    props: {
        overlay: { type: Boolean }
    },
    setup(__props) {
        const { locale, t } = useI18n();
        const open = ref(false);
        const rootRef = ref(null);
        const currentLocale = computed(() => locale.value);
        const changeLocale = async (newLocale) => {
            setAppLocale(newLocale);
            open.value = false;
            await nextTick();
        };
        const toggle = () => {
            open.value = !open.value;
        };
        const onDocumentPointerDown = (event) => {
            const root = rootRef.value;
            if (!root || !open.value)
                return;
            if (event.target instanceof Node && !root.contains(event.target)) {
                open.value = false;
            }
        };
        const onDocumentKeydown = (event) => {
            if (event.key === "Escape")
                open.value = false;
        };
        onMounted(() => {
            document.addEventListener("pointerdown", onDocumentPointerDown);
            document.addEventListener("keydown", onDocumentKeydown);
        });
        onBeforeUnmount(() => {
            document.removeEventListener("pointerdown", onDocumentPointerDown);
            document.removeEventListener("keydown", onDocumentKeydown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "rootRef",
                ref: rootRef,
                class: _normalizeClass(["language-switcher", {
                        'language-switcher--overlay': _ctx.overlay,
                        'language-switcher--open': open.value,
                    }])
            }, [
                _createElementVNode("button", {
                    class: "language-switcher__trigger",
                    type: "button",
                    "aria-label": _unref(t)('language.label'),
                    "aria-expanded": open.value,
                    "aria-haspopup": "listbox",
                    onClick: toggle
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        (currentLocale.value === 'es')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[0] || (_cache[0] = [
                                _createElementVNode("rect", {
                                    width: "3",
                                    height: "2",
                                    fill: "#c60b1e"
                                }, null, -1),
                                _createElementVNode("rect", {
                                    y: "0.5",
                                    width: "3",
                                    height: "1",
                                    fill: "#ffc400"
                                }, null, -1)
                            ])))
                            : (currentLocale.value === 'en')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[1] || (_cache[1] = [
                                    _createElementVNode("rect", {
                                        width: "60",
                                        height: "30",
                                        fill: "#012169"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                        d: "M0,0 60,30 M60,0 0,30",
                                        stroke: "#fff",
                                        "stroke-width": "6"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                        d: "M30,0 V30 M0,15 H60",
                                        stroke: "#fff",
                                        "stroke-width": "10"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                        d: "M30,0 V30 M0,15 H60",
                                        stroke: "#c8102e",
                                        "stroke-width": "6"
                                    }, null, -1)
                                ])))
                                : (currentLocale.value === 'it')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[2] || (_cache[2] = [
                                        _createElementVNode("rect", {
                                            width: "1",
                                            height: "2",
                                            fill: "#009246"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "1",
                                            width: "1",
                                            height: "2",
                                            fill: "#fff"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            x: "2",
                                            width: "1",
                                            height: "2",
                                            fill: "#ce2b37"
                                        }, null, -1)
                                    ])))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[3] || (_cache[3] = [
                                        _createElementVNode("rect", {
                                            width: "27",
                                            height: "18",
                                            fill: "#0d5eaf"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            fill: "#fff",
                                            d: "M0 2h27v2H0zm0 4h27v2H0zm0 4h27v2H0zm0 4h27v2H0z"
                                        }, null, -1),
                                        _createElementVNode("rect", {
                                            width: "10",
                                            height: "10",
                                            fill: "#0d5eaf"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            fill: "#fff",
                                            d: "M4 0h2v10H4zM0 4h10v2H0z"
                                        }, null, -1)
                                    ])))
                    ]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(currentLocale.value.toUpperCase()), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("i", {
                        class: "bi bi-chevron-down language-switcher__chevron",
                        "aria-hidden": "true"
                    }, null, -1))
                ], 8, _hoisted_1),
                _withDirectives(_createElementVNode("ul", {
                    class: "language-switcher__menu",
                    role: "listbox",
                    "aria-label": _unref(t)('language.label')
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SUPPORTED_LOCALES), (code) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: code,
                            role: "none"
                        }, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["language-switcher__option", { active: currentLocale.value === code }]),
                                type: "button",
                                role: "option",
                                "aria-selected": currentLocale.value === code,
                                onClick: ($event) => (changeLocale(code))
                            }, [
                                _createElementVNode("span", _hoisted_10, [
                                    (code === 'es')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[5] || (_cache[5] = [
                                            _createElementVNode("rect", {
                                                width: "3",
                                                height: "2",
                                                fill: "#c60b1e"
                                            }, null, -1),
                                            _createElementVNode("rect", {
                                                y: "0.5",
                                                width: "3",
                                                height: "1",
                                                fill: "#ffc400"
                                            }, null, -1)
                                        ])))
                                        : (code === 'en')
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[6] || (_cache[6] = [
                                                _createElementVNode("rect", {
                                                    width: "60",
                                                    height: "30",
                                                    fill: "#012169"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M0,0 60,30 M60,0 0,30",
                                                    stroke: "#fff",
                                                    "stroke-width": "6"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M30,0 V30 M0,15 H60",
                                                    stroke: "#fff",
                                                    "stroke-width": "10"
                                                }, null, -1),
                                                _createElementVNode("path", {
                                                    d: "M30,0 V30 M0,15 H60",
                                                    stroke: "#c8102e",
                                                    "stroke-width": "6"
                                                }, null, -1)
                                            ])))
                                            : (code === 'it')
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[7] || (_cache[7] = [
                                                    _createElementVNode("rect", {
                                                        width: "1",
                                                        height: "2",
                                                        fill: "#009246"
                                                    }, null, -1),
                                                    _createElementVNode("rect", {
                                                        x: "1",
                                                        width: "1",
                                                        height: "2",
                                                        fill: "#fff"
                                                    }, null, -1),
                                                    _createElementVNode("rect", {
                                                        x: "2",
                                                        width: "1",
                                                        height: "2",
                                                        fill: "#ce2b37"
                                                    }, null, -1)
                                                ])))
                                                : (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[8] || (_cache[8] = [
                                                    _createElementVNode("rect", {
                                                        width: "27",
                                                        height: "18",
                                                        fill: "#0d5eaf"
                                                    }, null, -1),
                                                    _createElementVNode("path", {
                                                        fill: "#fff",
                                                        d: "M0 2h27v2H0zm0 4h27v2H0zm0 4h27v2H0zm0 4h27v2H0z"
                                                    }, null, -1),
                                                    _createElementVNode("rect", {
                                                        width: "10",
                                                        height: "10",
                                                        fill: "#0d5eaf"
                                                    }, null, -1),
                                                    _createElementVNode("path", {
                                                        fill: "#fff",
                                                        d: "M4 0h2v10H4zM0 4h10v2H0z"
                                                    }, null, -1)
                                                ])))
                                ]),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)(_unref(localeDisplayKey)(code))), 1),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(code.toUpperCase()), 1)
                            ], 10, _hoisted_9)
                        ]));
                    }), 128))
                ], 8, _hoisted_8), [
                    [_vShow, open.value]
                ])
            ], 2));
        };
    }
});
